<template>
    <div class="activeOperateIndex spackage padding-20 bgc box-shadow">
       <div class="head">
            <div class="flex left">
                <el-button @click="handleAdd()" type="primary">新增活动</el-button>
            </div>
            <div class="flex right">
                <el-select v-model="apidata.status" class="select item " placeholder="活动状态">
                    <el-option v-for="item in status" :key="item.key" :label="item.label" :value="item.key"></el-option>
                </el-select>
                <el-input style="width:200px" v-model="apidata.title" placeholder="请输入活动名称" class="input item"></el-input>
                <el-button type="primary" @click="search" class="item">搜索</el-button>
            </div>
       </div>

        <el-table rel="singleTable" :data="tableInfo" style="width: 100%;">
            <el-table-column fixed  label="活动名称" align="left"  width="300">
                <template slot-scope="scope">
                    <div class="nameBox">
                        <div class="iconBox">
                            <img :src="scope.row.coveratturlid" :alt="scope.row.title" v-if="scope.row.coveratturlid !== ''">
                            <div v-else class='iconBox-block'></div>
                        </div>
                        <div class="rightBox">
                            <div class="title">
                                <el-tooltip class="item" effect="dark" :content="scope.row.title" placement="top-start">
                                    <div class="text">{{scope.row.title}}</div>
                                </el-tooltip>
                            </div>
                            <div class="type4">
                                <template v-if="scope.row.isfree == 0">免费</template>
                                <template v-else>¥ {{scope.row.minprice}} - {{scope.row.maxprice}}</template>
                                <span class="thirdparty" v-if="scope.row.enrolleventsource == 2">三方活动</span>
                                <span v-if="scope.row.ispublic == 0">已隐藏</span>
                            </div>
                        </div>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="活动时间" align="center" width="180px">
                <template slot-scope="scope">
                   <p>{{scope.row.begintime}}</p>
                    <p>至</p>
                    <p>{{scope.row.endtime}}</p>
                </template>
            </el-table-column>

            <el-table-column label="报名时间" align="center" width="180px">
                <template slot-scope="scope">
                    <p>{{scope.row.enrollbegintime}}</p>
                    <p>至</p>
                    <p>{{scope.row.enrollendtime}}</p>
                </template>
            </el-table-column>

            <el-table-column label="状态" align="center">
                 <template slot-scope="scope">
                    <p style="color: #67C23A" v-if="scope.row.status == 10"> {{scope.row.statustext}} </p>
                    <p style="color: #606266" v-else-if="scope.row.status == 100"> {{scope.row.statustext}} </p>
                    <p style="color: #E6A23C" v-else> {{scope.row.statustext}} </p>

                 </template>
                <!-- <p style="color: #67C23A">活动中 10</p>
                <p style="color: #606266">已结束 100</p>
                <p style="color: #E6A23C">未开始</p> -->
            </el-table-column>

            <el-table-column label="报名数据"  align="center" width="130px">
               <template slot-scope="scope">
                    <p v-if="scope.row.enrolleventsource === 1">报名人数：{{scope.row.applycount}}人</p>
                    <p v-if="scope.row.enrolleventsource === 1">报名成功：{{scope.row.applyokcount}}</p>
                    <p v-if="scope.row.enrolleventsource === 1" class="hover">待审核：{{scope.row.auditcount}}人
                        <span @click="ticketinfolist(scope.row.ticketinfo)" v-if="scope.row.ticketinfo.length > 0"><img src="./../../common/images/activeOperate/down.png" alt="down"></span>
                    </p>
                    <p v-if="scope.row.enrolleventsource === 2">--</p>
               </template>
            </el-table-column>

             <el-table-column label="票券数量" prop="ticketcount" align="center">
                 <template slot-scope="scope">
                     <p v-if="scope.row.enrolleventsource === 1">{{scope.row.ticketcount}}</p>
                     <p v-else>--</p>
                 </template>
             </el-table-column>

             <el-table-column label="销量" prop="ordersucccount" align="center">
                 <template slot-scope="scope">
                     <p v-if="scope.row.enrolleventsource === 1">{{scope.row.ordersucccount}}</p>
                     <p v-else>--</p>
                 </template>
             </el-table-column>

             <el-table-column label="操作" align="right" width="226">
                 <template slot-scope="scope">
                    <div class="position">
                          <!-- status 状态 0, 待发布 10, 进行中 11, 暂停中 30, 已完成 100,已取消 -->
                        <p @click="goto('OrderManage', scope.row.eventinnerid)" v-if="scope.row.enrolleventsource === 1">订单</p><span v-if="scope.row.enrolleventsource === 1">|</span>
                        <p @click="goto('RollCall', scope.row.eventinnerid)" v-if="scope.row.enrolleventsource === 1">名单</p><span v-if="scope.row.enrolleventsource === 1">|</span>
                        <p @click="editActive(scope.row)">编辑</p>|
                        <!-- <p @click="shareSetClick(scope.row)">分享</p>| -->
                        <p @click="shareActive(scope.row.shareurl)" v-if="scope.row.enrolleventsource === 1">分享</p><span v-if="scope.row.enrolleventsource === 1">| </span>
                        <p @click="updateStatus(scope.row.eventinnerid, 8)" v-if="scope.row.enrolleventsource === 2 && (scope.row.status !== 100 && scope.row.status !== 30) && scope.row.ispublic == 0">显示</p><span v-if="scope.row.enrolleventsource === 2 && (scope.row.status !== 100 && scope.row.status !== 30) && scope.row.ispublic == 0">| </span>
                        <p @click="updateStatus(scope.row.eventinnerid, 9)" v-if="scope.row.enrolleventsource === 2 && (scope.row.status !== 100 && scope.row.status !== 30) && scope.row.ispublic == 1">隐藏</p><span v-if="scope.row.enrolleventsource === 2 && (scope.row.status !== 100 && scope.row.status !== 30) && scope.row.ispublic == 1">| </span>
                        <p @click="copyEvent(scope.row)" v-if="scope.row.enrolleventsource === 2">复制</p><span v-if="scope.row.enrolleventsource === 2 && scope.row.status !== 100 && scope.row.status !== 30">| </span>
                        <p @click="cancelActive(scope.row.eventinnerid)" v-if="scope.row.enrolleventsource === 2 && scope.row.status !== 100 && scope.row.status !== 30">取消</p>

                         <el-dropdown  v-if="scope.row.enrolleventsource === 1">
                                <p>更多</p>
                                <el-dropdown-menu>
                                    <el-dropdown-item @click.native="goto('SignManage', scope.row.eventinnerid)" v-if="scope.row.isopensignin == 1">签到管理</el-dropdown-item>
                                    <!-- 展示签到管理显示 -->
                                    <el-dropdown-item @click.native="goto('ApplySet', scope.row.eventinnerid)" v-if="scope.row.enrolleventsource === 1">报名设置</el-dropdown-item>
                                    <!-- <el-dropdown-item @click.native="goto('ApplySet', 'ysfFdNouOBAeRZs0')">报名设置</el-dropdown-item> -->
                                    <el-dropdown-item @click.native="goto('ActivePosterManagement', scope.row.eventinnerid)" v-if="scope.row.enrolleventsource === 1">海报设置</el-dropdown-item>
                                    <el-dropdown-item @click.native="goto('UserComment', scope.row.eventinnerid)" v-if="scope.row.enrolleventsource === 1">用户评论</el-dropdown-item>

                                    <el-dropdown-item v-if="scope.row.status !== 100 && scope.row.status !== 30 && scope.row.ispublic == 0"  @click.native="updateStatus(scope.row.eventinnerid, 8)">显示活动</el-dropdown-item>
                                    <el-dropdown-item v-if="scope.row.status !== 100 && scope.row.status !== 30 && scope.row.ispublic == 1"  @click.native="updateStatus(scope.row.eventinnerid, 9)">隐藏活动</el-dropdown-item>
                                    <!-- 已取消活动不展示 -->

                                    <el-dropdown-item @click.native="copyEvent(scope.row)">复制活动</el-dropdown-item>

                                    <el-dropdown-item v-if="scope.row.status !== 100 && scope.row.status !== 30" @click.native="cancelActive(scope.row.eventinnerid)">取消活动</el-dropdown-item>
                                    <!-- 已取消活动不展示 -->
                                    <el-dropdown-item v-if="!scope.row.isinnerrecommend" @click.native="setEventRecommend(scope.row)">推荐活动</el-dropdown-item>
                                    <el-dropdown-item v-if="scope.row.isinnerrecommend" @click.native="setEventRecommend(scope.row)">取消推荐</el-dropdown-item>
                                </el-dropdown-menu>
                          </el-dropdown>
                      <!-- 结束情况下 -->
                    </div>
                </template>
             </el-table-column>
        </el-table>

        <el-pagination background layout="prev, pager, next" :total="totalPage"  @current-change="fPage"></el-pagination>


        <el-dialog title="进度" :visible.sync="silderDialogVisible" width="500px">
            <div class="silder">
                <template v-for="item in ticketinfo">
                    <p class="title">{{item.ticketname}}</p>
                    <span class="name">{{item.salecount}} / {{item.ticketcount}}</span>
                    <el-progress :percentage="(item.salecount / item.ticketcount * 100)" :format="format"></el-progress>
                </template>
                <!-- 免费票
                <el-progress :percentage="50" :format="format"></el-progress>
                vip
                <el-progress :percentage="10" :format="format"></el-progress>
                四人票
                <el-progress :percentage="6" :format="format"></el-progress> -->
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="silderDialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>

        <CopyShareDialog :shareeventurl="shareeventurl" :imgurl="imgurl" :copyShareStatus='copyShareStatus' @closeCopyShareStatus='closeCopyShareStatus'></CopyShareDialog>
        <CancelActive :eventinnerid="eventinnerid" @cancelDialogActive="_cancelDialogActive" ref="cancelActiveDislog"></CancelActive>
        <SelectWay ref="selectWay" />
    </div>
</template>

<script>
import fecha from 'element-ui/src/utils/date'
import { urlToQRCode} from 'common/js/tools'
import { mapActions} from 'vuex' // 引入 vuex 组件
import $ from 'jquery'
import {checkModule} from '@/api/api'
import {getEnrolleventinfoList, updateEnrolleventinfoStatus, setEventRecommend} from 'api/activeApi'
// import ActiveType from './components/ActiveType.vue'
import CopyShareDialog from 'views/taskTools/helpManagement/components/CopyShareDialog'
import CancelActive from './components/cancelActive'
import SelectWay from './components/selectWay'

import { log } from 'util'
// import HelpRankPop from 'views/taskTools/helpManagement/components/HelpRankPop'

export default {
        name: "activeOperateIndex",
        data() {
          return {
              eventinnerid: '', // 活动ID
              silderDialogVisible: false,
              activeType: false,
              imgurl: '',
              tableInfo: [],    //表单数据
              status: [{key: '', label: '全部状态'},{key: 9, label: '未开始'},{key: 10, label: '进行中'},{key: 30, label: '已结束'},{key: 100, label: '已取消'}], // 状态位
              totalPage: 0,    //数据条数
              copyShareStatus: false, // 分享状态
              copyDialogVisibleStatus: false, // 控制复制活动的弹窗
              currentPage: 1, // 当前页
              shareeventurl: '', // 分享链接
              apidata: {
                status: '',     // 状态
                title: '',      // 活动名称
                page: '',       // 当前页数
                pagesize: 10    // 每页展示条数
              },
              ticketinfo: [],   // 进度列表 ticketname   票种名称   ticketcount 票数    salecount  售卖票数

          }
        },
        mounted() {
            this.activelist(1)
        },
        methods: {
            // 复制活动
            copyEvent(row) {
                if (row.enrolleventsource === 1) {
                    this.$router.push({
                        name: 'CreateActive',
                        query: {
                            eventinnerid: row.eventinnerid,
                            title: 'copy'
                        }
                    })
                } else {
                    this.$router.push({
                        name: 'CreateOtherActive',
                        query: {
                            eventinnerid: row.eventinnerid,
                            title: 'copy'
                        }
                    })
                }
            },
            // 编辑活动
            editActive(row) {
                console.log(row)
                if (row.enrolleventsource === 1) {
                    this.$router.push({
                        name: 'CreateActive',
                        query: {
                            eventinnerid: row.eventinnerid
                        }
                    })
                } else {
                    this.$router.push({
                        name: 'CreateOtherActive',
                        query: {
                            eventinnerid: row.eventinnerid
                        }
                    })
                }
            },
            // 新增活动
            handleAdd() {
                let user = JSON.parse(sessionStorage.user)
                if (user.systypecode == '2') {
                    this.$refs.selectWay.open()
                } else {
                    var params = {
                        moduleid: 'A23'
                    }
                    checkModule({
                        data: Object.assign({}, params),
                        success: data => {
                            console.log(data)
                            this.$router.push({name: 'CreateActive'})
                        },
                        error: data => {
                            console.log('error：', data)
                            this.$message.error(data.msg)
                        }
                    })
                }
                
            },
            format(percentage) {    // 进度条状态
                // return `${percentage}/20`;
            },
            ticketinfolist(info) {  // 进度条展示
                this.silderDialogVisible = true

                // 数据初始化
                this.ticketinfo = []

                this.ticketinfo = info
            },
            activelist(page) {  // 活动列表
                this.apidata.page = page    // 取得页数
                this.setLoading(true)

                getEnrolleventinfoList({
                    data: this.apidata,
                    success: data => {
                        this.tableInfo = data.data.content
                        this.totalPage = data.data.pageinfo.rowCount

                        console.log(this.tableInfo)
                        this.setLoading(false)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            search() {  // 搜索
                this.activelist(1)
            },
            closeCopyShareStatus(val) { // 关闭复制弹窗
                this.copyShareStatus = false
            },
            fPage(){    // 分页
                let clickPage = $(".el-pagination .active").html()
                this.activelist(clickPage)
            },
            goto(name, eventinnerid, title, copy) {    // 前往其他页面
                this.$router.push({name: name, query: {'eventinnerid': eventinnerid, 'title': title, 'copy': copy}})
            },
            cancelActive(eventinnerid) {    // 活动取消
                this.eventinnerid = eventinnerid

                this.$nextTick(() => {
                    this.$refs.cancelActiveDislog.open()
                })
            },
            _cancelDialogActive(type) { // 取消活动成功回调
                // 重置
                this.activelist(1)
            },
            shareActive(shareeventurl) {  // 分享活动
                this.copyShareStatus = true
                this.shareeventurl = shareeventurl
                this.imgurl = urlToQRCode(shareeventurl)

            },
            // 分享设置
            shareSetClick(val) {
                // console.log(val)
                this.$router.push({name: 'ShareSet', query: {eventinnerid: val.eventinnerid}})
            },

             // 修改活动状态
            updateStatus(innerid, type) {
            this.setLoading(true)

            let data = {eventinnerid: innerid, status: type}
            updateEnrolleventinfoStatus({
                   data: data,
                   success:data => {
                       this.$message.success('操作成功')
                        this.setLoading(false)

                        // 重置
                        this.activelist(1)
                   },
                   error:data => {
                        this.$message.success(data.msg)
                        this.setLoading(false)
                   }
               })
            },
            // 兑换码
            CDKClick(val) {
                // console.log(val)
                this.$router.push({name: 'Cdklist', query: {eventinnerid: val.eventinnerid}})
            },
            // 核销列表
            chargeOffClick(val) {
                // console.log(val)
                this.$router.push({name: 'ChargeOffList', query: {eventinnerid: val.eventinnerid}})
            },
            // 助力排行
            helpRankClick(val) {
                // console.log(val)
                this.$refs.helpRankList.openDialog(val)
            },
            // 推荐活动/取消推荐
            setEventRecommend(item) {
                let params = {
                    eventinnerid: item.eventinnerid,
                    iscommend: ''
                }
                if (item.isinnerrecommend) {
                    params.iscommend = 0
                } else {
                    params.iscommend = 1
                }
                this.setLoading(true)
                setEventRecommend({
                    data: params,
                    success: res => {
                        this.setLoading(false)
                        this.$message.success('操作成功')
                        if (params.iscommend) {
                            item.isinnerrecommend = 1
                        } else {
                            item.isinnerrecommend = 0
                        }
                    },
                    error: res => {
                        this.setLoading(false)
                        this.$message.error(res.msg)
                    }
                })
            },
            ...mapActions([
                'setLoading'
            ])
        },
        components: {
            // ActiveType,
            CopyShareDialog,
            CancelActive,
            SelectWay
            // HelpRankPop
        }
    }
</script>

<style lang="scss" type="text/scss">
@import "~common/scss/mixin";
@import "~common/scss/base";
    .el-tooltip__popper.is-dark {
        background: #fff
    }
    .activeOperateIndex {
        .hover {
            position: relative;
            img {
                width: 16px;
                transform: translateY(2px);
                cursor: pointer;
            }
        }
        .silder {
            .el-progress__text {
                display: none
            }
            .title {
                margin: 20px 0px 10px 0
            }
            .name {
                float: right;
                margin-left: 5px;
                font-size: 14.4px;
                color: #606266;
            }

        }
        // .silder {
        //     display: none;
        //     position: absolute;
        //     margin: auto;
        //     left: -50%;
        //     right: 0;
        //     z-index: 111;
        //     padding: 10px;
        //     width: 300px;
        //     background: #fff;
        // }
        // .el-table {
        //     overflow: inherit;
        // }
        // .hover:hover + .silder {
        //     display: block;
        // }

        .one-title {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .sub-title {
            display: -webkit-box;
            display: -webkit-inline-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            -moz-box-orient: vertical;
            -ms-box-orient: vertical;
            box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .el-input__icon {
            line-height: normal;
        }
        .head {
            margin-bottom: 30px;
        }

        .position,
        .head,
        .flex {
            display: flex;
            flex-wrap: nowrap;
            -ms-flex-wrap: nowrap;
            width: 100%;
        }
        .flex.left {
            align-content: flex-start;
        }
        .flex.right {
            align-content: flex-end;
            justify-content: flex-end;
        }

        .head {
            .select {
                width: 108px;
            }
            .input {
                width: 134px;
            }
            .item {
                margin-left: 15px
            }
        }
        .el-pagination {
            margin-top: 20px;
            text-align: center;
        }

        .position {
            color: #439FFE;
            width: auto;
            float: right;

            p {
                margin: 0 5px;
                color: #439FFE;
                cursor: pointer;
            }
        }

        .type-1 {
            color: #67C23A
        }
        .type-2 {
            color: #606266
        }
        .type-3 {
            color: #F56C6C
        }
        .type-4 {
            color: #E6A23C
        }
        .help_rank_pop_box {
            .el-dialog__wrapper {
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: left;
            }
            .el-dialog {
                width: 678px;
                margin: 0!important;
            }
        }

        .nameBox{
            display: flex;
                .iconBox{
                    width: 106px;
                    height: 60px;
                    margin-right: 10px;
                    img{
                        min-width: 106px;
                        width: 106px;
                        height: 60px;
                    }
                }
                .iconBox-block {
                    display: block;
                    width: 106px;
                    height: 60px;
                    background: #ccc
                }
                .rightBox{
                    min-width: 104px;
                    display: flex;
                    flex-direction: column;
                    .title{
                        height: 40px;
                        line-height: 20px;
                        overflow: hidden;
                        .text{
                            // float: right;
                            /* "margin-left"要等于".wrap::before"的宽度 */
                            // margin-left: -10px;
                            width: 100%;
                            word-break: break-all;
                            text-align: left;
                            font-size: 14px;
                            // font-size: 0.48rem;
                        }
                        // &::before {
                        //     float: left;
                        //     content: '';
                        //     width: 10px;
                        //     height: 100%;
                        // }
                        &::after {
                            float: right;
                            content: "...";
                            /* 行高与".wrap"设置的一致即可 */
                            height: 40px;
                            line-height: 20px;
                            /* 设置三个省略号的宽度,大于字体文本宽度即可,数值随意。并使盒子不占位置 */
                            width: 37px;
                            margin-left: -37px;
                            /* 移动省略号位置 */
                            position: relative;
                            left: 101.9%;
                            bottom: 20px;
                            font-weight: 600;
                            padding-right: 1px;
                            background: #fff;
                            transition: all 0.5s;
                            text-align: left;
                        }
                    }
                    .type{
                        text-align: left;
                    }
                    .type1{
                        color: #67C23A;
                    }
                    .type2{
                        color: #409EFF;
                    }
                    .type3{
                        color: #E6A23C;
                    }
                    .type4{
                        text-align: left;
                        color:  #F56C6C;
                        span {
                            margin-left: 5px;
                            padding: 2px 5px;
                            font-size:10px;
                            color: #409EFF;
                            border: solid 1px #409EFF;
                            border-radius: 2px;
                        }
                        .thirdparty {
                            color: #FFA904;
                            border: none;
                            font-size: 14px;
                        }
                    }
                }
            }
    }
</style>
